var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "hex-shape",
    fillRule: "evenodd",
    stroke: "none",
    d: "M 50.015167 -0.00016 L 93.030655 24.825249 L 93.030655 74.476044 L 50.015167 99.320999 L 7.018764 74.476044 L 7.018764 24.825249 L 50.015167 -0.00016 Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "hex-icon",
    transform: "translate(25,25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.618 9.309L14.179 5.59c-.352-.176-.735-.264-1.118-.264-.419 0-.837.105-1.214.315L5.286 9.286C4.492 9.727 4 10.563 4 11.471v8.091c0 .911.495 1.75 1.293 2.189l6.557 3.615c.375.207.791.311 1.207.311.383 0 .766-.088 1.118-.264l7.443-3.722C22.465 21.268 23 20.402 23 19.455v-7.91C23 10.598 22.465 9.732 21.618 9.309zM32.618 27.309l-7.439-3.719c-.352-.176-.735-.264-1.118-.264-.419 0-.837.105-1.214.315l-6.561 3.645C15.492 27.727 15 28.563 15 29.471v8.091c0 .911.495 1.75 1.293 2.189l6.557 3.615c.375.207.791.311 1.207.311.383 0 .766-.088 1.118-.264l7.443-3.722C33.465 39.268 34 38.402 34 37.455v-7.91C34 28.598 33.465 27.732 32.618 27.309zM42.618 9.309L35.179 5.59c-.352-.176-.735-.264-1.118-.264-.419 0-.837.105-1.214.315l-6.561 3.645C25.492 9.727 25 10.563 25 11.471v8.091c0 .911.495 1.75 1.293 2.189l6.557 3.615c.375.207.791.311 1.207.311.383 0 .766-.088 1.118-.264l7.443-3.722C43.465 21.268 44 20.402 44 19.455v-7.91C44 10.598 43.465 9.732 42.618 9.309z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.050ad58b0dad452d9d5d12dffae8d853.svg";
export { ForwardRef as ReactComponent };